/** `storage` module backend validators tokens */
export enum StorageBackendValidatorsEnum {
  /** Check that file with that identifier exists */
  FILE_ASSERT_EXISTS_BY_ID = 'storage/file::assert-exists-by-id',
  /** Check that file with identifier in that DTO exists */
  FILE_ASSERT_EXISTS_BY_DTO = 'storage/file::assert-exists-by-dto',
}
